<template>
	<div class="body">
		<div class="close-btn" v-on:click="close">
			<i title="close" class="material-icons md-18">close</i>
		</div>
		<div class="title">REMOVE COLLECTION</div>
		<div class="p-3">
			<form class="category form-group" v-on:submit.prevent="formSubmit">
				<div class="modal-property-row">
					Are you sure you would like to delete this collection?
				</div>
				<div class="modal-actions">
					<button class="btn btn-dark float-right" type="submit">Remove</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>

export default {
	name:'collectionRemove',
	props: {
		collection:{
			type:Object,
		},
	},
	computed:{
		planActive:function(){
			return this.$store.state.plan.active;
		},
	},
	data: function(){
		return {
			error:null,
			loading: true,
			loadError: null,
		}
	},
	methods:{
		close:function(){
			this.$emit('close');
		},
		formSubmit:async function(){
			try {
				this.loadError = null;
				this.loading = true;
				await this.$store.dispatch('COLLECTION_REMOVE', {collectionId:this.$route.params.collectionId});
				// route user back to collections
				this.$router.push({
					name: 'collections', 
					params:{}
				});
				this.loading = false;
			} catch(e){
				this.loadError = e;		
			}
		},
	}
};

</script>


// WEBPACK FOOTER //
// src/components/collection/collection-remove.vue